import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Input } from "@/components/ui/input";

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 10 || !/[A-Za-z]/.test(pw) || !/\d/.test(pw)) return setError("Min. 10 znaków, litery i cyfry.");
    if (pw !== confirm) return setError("Hasła nie są identyczne.");
    setError("");
    setSaving(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Hasło zostało ustawione. Zaloguj się nowym hasłem.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Nie udało się ustawić hasła.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <form data-testid="reset-password-form" onSubmit={submit} noValidate className="w-full max-w-sm bg-card border border-border rounded-2xl p-8 shadow-xl">
        <Logo className="h-10 text-slate-900 dark:text-white" showTagline={false} />
        <h1 className="font-display font-bold text-xl mt-4">Ustaw nowe hasło</h1>
        <p className="text-sm text-muted-foreground mt-1">Co najmniej 10 znaków, litery i cyfry.</p>
        {!token ? (
          <p data-testid="reset-password-no-token" className="mt-6 text-sm text-rose-500">Brak tokenu w adresie. Użyj linku z e-maila lub poproś o nowy.</p>
        ) : (
          <>
            <div className="mt-6 space-y-4">
              <Input data-testid="reset-password-new" type="password" autoComplete="new-password" placeholder="Nowe hasło" value={pw} onChange={(e) => setPw(e.target.value)} />
              <Input data-testid="reset-password-confirm" type="password" autoComplete="new-password" placeholder="Powtórz nowe hasło" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              {error && <p data-testid="reset-password-error" className="text-xs text-rose-500">{error}</p>}
            </div>
            <button data-testid="reset-password-submit" type="submit" disabled={saving} className="mt-6 w-full bg-brand-teal hover:bg-brand-tealDark disabled:opacity-60 text-white font-semibold py-2.5 rounded-full text-sm transition-colors inline-flex items-center justify-center gap-2">
              {saving && <Loader2 size={15} className="animate-spin" />} Zapisz hasło
            </button>
          </>
        )}
        <Link to="/admin" data-testid="reset-password-back" className="mt-4 flex items-center justify-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft size={13} /> Wróć do logowania
        </Link>
      </form>
    </div>
  );
}
